export default __webpack_public_path__ + "static/footerLogo-b7a884bc80046ed7c07dc821e67f3abd.png";